import { Button } from '@enterprise-ui/canvas-ui-react'
import { PurchaseOrderInterface, ShipmentRowInterface } from 'common/types'
import { useGlobalContext } from 'context/GlobalContext'
import { useShipmentManagementContext } from 'context/ShipmentManagementContext'
import SubmitChanges from 'components/Modal/submitChanges'
import { shipmentsModified } from 'components/Shipments/utils'
import { uniqByProp } from 'common/utils'
import { useQueryClient } from '@tanstack/react-query'

export const ModifyShipments = () => {
  const { globalDispatch } = useGlobalContext()
  const { shipmentManagementState, shipmentManagementDispatch } =
    useShipmentManagementContext()
  const queryClient = useQueryClient()
  const purchaseOrders: Array<PurchaseOrderInterface> = Object.values(
    shipmentManagementState.shipmentsByPurchaseOrderKey,
  )

  const shipmentsFromShipmentView =
    Object.values(shipmentManagementState.shipmentsViewData) || []

  const shipmentsFromPurchaseOrders = purchaseOrders.reduce(
    (prev: Array<any>, curr: any) => {
      return [...prev, ...Object.values(curr)]
    },
    [],
  )

  const loadShipments: Array<PurchaseOrderInterface> = Object.values(
    shipmentManagementState.shipmentsByLoadIdKey,
  )

  const shipmentsFromLoads = loadShipments.reduce(
    (prev: Array<any>, curr: any) => {
      return [...prev, ...Object.values(curr)]
    },
    [],
  )

  const shipmentsCombined = [
    ...shipmentsFromPurchaseOrders,
    ...shipmentsFromLoads,
    ...shipmentsFromShipmentView,
  ].filter(shipmentsModified)

  const uniqueById = uniqByProp('bookingId')
  const filteredShipmentsModifiedReviewed = uniqueById(shipmentsCombined)

  const invalidShipmentsModifiedReviewed = [
    ...shipmentsFromPurchaseOrders,
    ...shipmentsFromShipmentView,
    ...shipmentsFromLoads,
  ].filter(
    (shipment: ShipmentRowInterface) =>
      !shipment.toBeCancelled && shipment.hasInvalidDimensions,
  )

  const hasPickupDateValidationErrors = shipmentsFromPurchaseOrders.filter(
    (shipment: ShipmentRowInterface) => {
      return (
        !shipment.toBeCancelled &&
        shipment.pickupDate !== shipment.original_pickupDate &&
        !shipment.pickupReasonCode
      )
    },
  )

  const hasShipmentsToUpdate =
    hasPickupDateValidationErrors.length === 0 &&
    invalidShipmentsModifiedReviewed.length === 0 &&
    filteredShipmentsModifiedReviewed.length > 0

  const handleModalClose = () => {
    shipmentManagementDispatch({ type: 'RESET_SHIPMENT_MODIFICATIONS' })
    shipmentManagementDispatch({ type: 'CLEAR_SHIPMENTS_VIEW_DATA' })
    queryClient.invalidateQueries({ queryKey: ['shipments-by-po'] })
    queryClient.invalidateQueries({ queryKey: ['shipments-by-filters'] })
  }

  return (
    <Button
      className="hc-ma-normal"
      data-testid="button-shipment-checkout"
      disabled={!hasShipmentsToUpdate}
      type="primary"
      onClick={() => {
        globalDispatch({
          type: 'SET_MODAL',
          payload: {
            template: SubmitChanges,
            size: 'expanded',
            props: {
              onClose: handleModalClose,
            },
          },
        })
      }}
    >
      Review and Submit({filteredShipmentsModifiedReviewed.length})
    </Button>
  )
}
